import React from 'react';
import createSvgIcon from '../utils/createSvg';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M109.8 254.4H283V83.1h-39v108.7L90.4 35.6 63 61.6l153.6 156H109.8z"
})), 'TrendDownIcon');